/** StatusDot — three-state health dot per design system §5.5. */

type Health = "green" | "yellow" | "red" | "gray";

const COLOR: Record<Health, string> = {
  green: "var(--success)",
  yellow: "var(--warning)",
  red: "var(--danger)",
  gray: "var(--text-dim)",
};

export default function StatusDot({ health, pulse = false }: { health: Health; pulse?: boolean }) {
  return (
    <span
      className={`inline-block w-2 h-2 rounded-full shrink-0 ${pulse ? "animate-pulse-live" : ""}`}
      style={{ background: COLOR[health], boxShadow: health !== "gray" ? `0 0 4px ${COLOR[health]}` : undefined }}
    />
  );
}
